import React, { Component } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { IntlActions } from 'react-redux-multilingual'
import Pace from 'react-pace-progress'

// Import custom components
import store from '../../../store';
import NavBar from "./common/custom_reg_navbar";
//import SideBar from "./common/sidebar";
//import CartContainer from "./../../../containers/CartContainer";
//import TopBar from "./common/topbar";
import { changeCurrency } from '../../../actions'
import { connect } from "react-redux";
//import TopBarDark from "./common/topbar-dark";
import LogoImage from "./common/logo";

class HeaderRegistration extends Component {

	constructor(props) {
		super(props);

		this.state = {
			isLoading: false
		}
	}
	/*=====================
		 Pre loader
		 ==========================*/
	componentDidMount() {
		setTimeout(function () {
			document.querySelector(".loader-wrapper").style = "display: none";
		}, 2000);
	}

	componentWillMount() {
		window.addEventListener('scroll', this.handleScroll);
	}
	componentWillUnmount() {
		window.removeEventListener('scroll', this.handleScroll);
	}

	handleScroll = () => {
		let number = window.pageXOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;

		if (number >= 300) {
			if (window.innerWidth < 576) {
				document.getElementById("sticky").classList.remove('fixed');
			} else
				document.getElementById("sticky").classList.add('fixed');
		} else {
			document.getElementById("sticky").classList.remove('fixed');
		}
	}

	changeLanguage(lang) {
		store.dispatch(IntlActions.setLocale(lang))
	}

	openNav() {
		var openmyslide = document.getElementById("mySidenav");
		if (openmyslide) {
			openmyslide.classList.add('open-side')
		}
	}
	openSearch() {
		document.getElementById("search-overlay").style.display = "block";
	}

	closeSearch() {
		document.getElementById("search-overlay").style.display = "none";
	}

	load = () => {
		this.setState({ isLoading: true });
		fetch().then(() => {
			// deal with data fetched
			this.setState({ isLoading: false })
		})
	};

	render() {

		return (
			<div>
				<div id="sticky" className="sticky">
					{this.state.isLoading ? <Pace color="#27ae60" /> : null}
					<div className="mobile-fix-option"></div>


					<div className="container-fluid" >

						<div className="header">

							<div className="brand-logo ">
								<LogoImage logo={this.props.logoName} />
							</div>



							<h3 className='header_title' >Appointment Form</h3>
							<div className="menu-right pull-right">

								{/*Top Navigation Bar Component*/}
								<NavBar />


							</div>
						</div>

					</div>
				</div>

				<br></br>
			</div>
		)
	}
}

export default connect(null,
	{ changeCurrency }
)(HeaderRegistration);